import { env } from "./env";

/** Join base + path safely, no double slashes */
export function assetUrl(path: string) {
  const base = env.ASSETS_BASE_URL.replace(/\/+$/, "");
  const p = path.replace(/^\/+/, "");
  return `${base}/${p}`;
}

/** Optionally append width/quality hints, useful once you’re on CloudFront/S3 with image lambda or CDN transforms */
export function assetUrlWithParams(path: string, params?: Record<string, string | number | boolean>) {
  const url = new URL(assetUrl(path));
  if (params) Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, String(v)));
  return url.toString();
}
